/**
 * @module mapbs.components.searchtip.searchtip
 */

import angular from 'angular';

const moduleSearchtip = angular.module('mapbsSearchtipModule', []);

const SearchtipDirective = function () {
    return {
        restrict: 'A',
        scope: false,
        controller: 'mapbsSearchtipController as searchtipCtrl',
        /**
     * @param {angular.Scope} scope Scope.
     * @param {angular.JQLite} element Element.
     * @param {angular.Attributes} attrs Attributes.
     * @param {mapbs.SearchtipController} controller Controller.
     */
        link(scope, element, attrs, controller) {
            controller.init(element, attrs);
        },
    };
};

moduleSearchtip.directive('mapbsSearchtip', SearchtipDirective);

class SearchtipController {
    /**
   * @param {angular.$compile} $compile Angular compile service.
   * @param {!angular.Scope} $scope Scope.
   *
   * @constructor
   * @private
   * @ngInject
   */
    constructor($compile, $scope) {
    /**
     * @type {angular.$compile}
     * @private
     */
        this.$compile_ = $compile;

        /**
     * @type {angular.Scope}
     * @private
     */
        this.$scope_ = $scope;

    }

    init(element, attrs) {
        this.element_ = element;
        this.attrs_ = attrs;
        this.handleSearchtipPopover_();
    }

    /**
   * @private
   */
    handleSearchtipPopover_() {
        this.preparePopover_();
        this.registerPopover_();
    }

    /**
   * @private
   */
    preparePopover_() {
        this.content_ = document.createElement('DIV');
        this.content_.setAttribute('mapbs-searchtipcontent', '');
        this.content_.setAttribute(
            'mapbs-searchtipcontent-data',
            'mainCtrl.searchtipData'
        );
        this.content_.setAttribute(
            'mapbs-searchtipcontent-gmfuser',
            'mainCtrl.gmfUser'
        );
        const scope = this.$scope_.$new(true);
        this.$compile_(this.content_)(scope.$parent);
    }

    /**
   * @private
   */
    registerPopover_() {
        const gmfsearchElement = this.element_.find('.gmf-search')[0];
        const showDelay = 300;
        const hideDelay = 100;
        const displayDuration = 4000;
        $(gmfsearchElement).popover({
            container: gmfsearchElement,
            toggle: 'popover',
            trigger: this.attrs_.trigger,
            delay: {show: showDelay, hide: hideDelay},
            placement: this.attrs_.placement,
            html: true,
            content: this.content_,
        });

        $(this.element_.find('.gmf-search .tt-input')[0]).on('keydown', () => {
            setTimeout(() => {
                if (!$('.popover:hover').length) {
                    $(gmfsearchElement).popover('hide');
                }
            }, hideDelay);
        });

        $(gmfsearchElement).on('show.bs.popover', () => {
            if ($('.tt-input.ng-not-empty').length) {
                return false;
            }
        });

        if (this.attrs_.trigger === 'manual') {
            let mouseenterTimeout;
            $(gmfsearchElement)
        .on('mouseenter', () => {
            mouseenterTimeout = setTimeout(() => {
                $(gmfsearchElement).popover('show');
                setTimeout(() => {
                    if (!$('.popover:hover').length) {
                        $(gmfsearchElement).popover('hide');
                    }
                }, displayDuration);
            }, showDelay);
            $(gmfsearchElement).on('mouseleave', () => {
                setTimeout(() => {
                    $(gmfsearchElement).popover('hide');
                }, hideDelay);
            });
        })
        .on('mouseleave', () => {
            clearTimeout(mouseenterTimeout);
            setTimeout(() => {
                if (!$('.popover:hover').length) {
                    $(gmfsearchElement).popover('hide');
                }
            }, hideDelay);
        });
        }
    }
}

moduleSearchtip.controller('mapbsSearchtipController', SearchtipController);

export default moduleSearchtip;
